import Api from '../../../services';

export const getGuestBookings = (params) => {
  return (dispatch) => {
    return Api.guestApi.bookings.getGuestBookings(params).then((response) => {
      dispatch({
        type: 'GET_GUEST_BOOKINGS',
        data: response,
      });
      return response;
    });
  };
};

export const reviewBooking = (reviewId, data) => {
  return (dispatch) => {
    return Api.guestApi.bookings.reviewBooking(reviewId, data).then((response) => {
      dispatch({
        type: 'REVIEW_BOOKING',
        data: response,
      });
      return response;
    });
  };
};
